import { render, staticRenderFns } from "./minilinkUpgrade.vue?vue&type=template&id=7b478994&scoped=true&"
import script from "./minilinkUpgrade.vue?vue&type=script&lang=js&"
export * from "./minilinkUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./minilinkUpgrade.vue?vue&type=style&index=0&id=7b478994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b478994",
  null
  
)

export default component.exports